import * as types from '../constants/authConstants';
import * as coreTypes from '../../core/constants/coreConstants';
import * as api from '../../api/api';
import Tenant from '../../util/tenant';
import * as store from '../../api/localStore';
import { browserHistory } from 'react-router';
import _ from 'underscore';


export function loginSuccess(data) {
	return {
		type: types.LOGIN_SUCCESS,
		response: data
	};
}

export function logoutSuccess() {
	return {
		type: types.LOGOUT_SUCCESS
	};
}

export function loadProfileSuccess(data) {
	return {
		type: types.LOAD_PROFILE_SUCCESS,
		response: data
	};
}
export function confirmationSuccess(data) {
	return {
		type: types.ACCOUNT_CONFIRMATION_SUCCESS,
		response: data
	};
}
export function passwordResetSent(state) {
	return {
		type: types.PASSWORD_RESET_SENT,
		response: state
	};
}
export function setPasswordSuccess(data) {
	return {
		type: types.SET_PASSWORD_SUCCCESS,
		response: data
	};
}

export function getClientsSuccess(data) {
	return {
		type: types.GET_CLIENTS_SUCCESS,
		response: data
	};
}

export function confirmAccount(values) {
	return function (dispatch) {
		api.post("account/confirm", values, true).
			then(function (response) {
				dispatch(confirmationSuccess(response));
				browserHistory.push('/auth?mode=setpassword');
			}).catch(function () {
				alert('Confirmation failed!');
			});
	};
}

export function resetPassword(values) {
	return function (dispatch) {
		api.post("account/resetpassword", values, true).
			then(function () {
				dispatch(passwordResetSent(true));
			});
	};
}
export function getClientList(mobileNumber) {
	return function (dispatch) {
		api.get(`account/clients/${mobileNumber}`, true).
			then(function (response) {
				if (!response)
					return browserHistory.push('/contactus/errorDetailed/104');

				if (response.length > 1) {
					dispatch(getClientsSuccess(response));
					browserHistory.push(`/auth?mode=clientselection&username=${mobileNumber}`)
				} 
				else
					dispatch(navigateToClientSite(response[0], mobileNumber));
			});
	};
}

export function navigateToClientSite(client, username) {
	return function() {
		let currentTenant = window.location.hostname.split('.')[0];
		let port = window.location.port;
		let protocol = window.location.protocol;

		let newLocation = Tenant.isValid(currentTenant)
			?
			(window.location.hostname.replace(currentTenant, client))
			:
			(`${client}.${window.location.hostname}`);

		newLocation = port ? `${protocol}//${newLocation}:${port}/auth?mode=login&username=${username}` : `${protocol}//${newLocation}/auth?mode=login&username=${username}`;
		window.location.href = newLocation;
	};
}

export function navigateToRoot() {
	return function() {
		let currentTenant = window.location.hostname.split('.')[0];
		let port = window.location.port;
		let protocol = window.location.protocol;

		let newLocation = Tenant.isValid(currentTenant)
			?
			(window.location.hostname.replace(`${currentTenant}.`, ''))
			:
			(`${window.location.hostname}`);

		newLocation = port ? `${protocol}//${newLocation}:${port}/auth?mode=mobileverification` : `${protocol}//${newLocation}/auth?mode=mobileverification`;
		window.location.href = newLocation;
	};
}

export function checkIfClientValid() {
	let currentTenant = window.location.hostname.split('.')[0];
	return Tenant.isValid(currentTenant);
}

export function login(values) {
	return function (dispatch) {
		dispatch(function () {
			return {
				type: coreTypes.BEGIN_AJAX_CALL
			};
		});

		api.token(values).then(function (response) {
			if (response.access_token) {
				dispatch(loginSuccess(response));

				const alreadyOnClientDomain = checkIfClientValid();
				
				if (alreadyOnClientDomain)
					browserHistory.push('/');
				else if (response.clients && response.clients.split(",").length > 1)
					browserHistory.push('/auth?mode=clientSelection');
				else
					browserHistory.push('/');
			}
			else
				alert("Invalid Mobile Number or Password!");
		});
	};
}

export function easyLogin(values) {
	return function (dispatch) {
		api.easyLogintoken(values).then(function (response) {
			if (response.access_token) {
				dispatch(loginSuccess(response));

				if (values.redirectUrl)
					browserHistory.push('/'.concat(values.redirectUrl));
				else
					browserHistory.push('/booking/'.concat(response.jobId));
			}
			else
				alert("Invalid passcode or registration details!");
		});
	};
}

export function logout() {
	return function (dispatch) {
		dispatch(logoutSuccess());

		if (Tenant.getName() == 'invalid')
			dispatch(navigateToRoot());
		else
			browserHistory.push('/auth?mode=login');
	};
}

export function logoutAndNavigateToRoot() {
	return function (dispatch) {
		dispatch(navigateToRoot());
		dispatch(logoutSuccess());
	};
}

export function loadProfile() {
	return function (dispatch) {
		api.get("me").then(function (response) {
			dispatch(loadProfileSuccess(response));
		});
	};
}

export function setPassword(values) {
	return function () {
		api.post("account/setpassword", values, true).then(function () {
			browserHistory.push('/auth?mode=login');
		}).catch(function () {
			alert('Password reset failed! Try again by requesting a new reset link');
		});
	};
}

export function getClientMerchantPairs(claims = "", tenantId) {
	const pairs = _.map(claims.split(","), (pair) => { 
		const parts = pair.split(':');
		return { clientId: parts[0], merchantId: parts[1] }; 
	});

	return tenantId ? _.filter(pairs, (p) => p.clientId.toLowerCase() == tenantId.toLowerCase()) : pairs;
}

export function setSelectedMerchant(clientMerchantPair) {
	return {
		type: types.SET_SELECTED_MERCHANT,
		response: clientMerchantPair
	};
}

export function clearSelectedMerchant() {
	return {
		type: types.CLEAR_SELECTED_MERCHANT
	};
}

export function restoreAuthorisation() {
	return function (dispatch) {
		const accessToken = store.get('token');

		if (accessToken)
			dispatch(loginSuccess(JSON.parse(accessToken)));
	};
}


// WEBPACK FOOTER //
// ./app/auth/actions/authActions.js